export const COUPONS_INFO_SECTION_COOKIE = {
  // For compatibility with (current) JSP based coupons info
  // section cookie name must be the same in both cases
  name: 'coupons-instruction',
  value: 'true',
  options: {
    path: '/',
    maxAge: 24 * 60 * 60 * 365, // year
    secure: true,
    httpOnly: false,
  },
};
